/**
 * Global busy indicator. Increment / decrement via `start` / `stop` so
 * concurrent loaders don't race-condition the bar away. The PageProgress
 * component renders when `busy > 0`.
 */

let _count = $state(0);

export const progress = {
  get busy(): boolean {
    return _count > 0;
  },
};

export function start(): void {
  _count += 1;
}

export function stop(): void {
  _count = Math.max(0, _count - 1);
}

/** Convenience: wraps an async fn with start/stop. */
export async function withProgress<T>(fn: () => Promise<T>): Promise<T> {
  start();
  try {
    return await fn();
  } finally {
    stop();
  }
}
